module.exports = __webpack_public_path__ + "img/drawFadeText2.8ab86d54.png";